// shared/domain/coleccion.js  (utilidades puras sobre listas)

/** Conserva el primer elemento de cada `id`. Útil para vistas que repiten filas por ciclo (p. ej. parcelas_all). */
export const unicosPorId = (list = []) => {
  const vistos = new Set();
  return list.filter(item => (vistos.has(item.id) ? false : vistos.add(item.id)));
};

const aMillis = value => {
  const t = Date.parse(value);
  return isNaN(t) ? null : t;
};

/** Orden por registro más reciente primero: created_at (ISO) desc; empate o sin fecha -> id numérico desc. */
export const sortByRecientes = (list = []) =>
  [...list].sort((a, b) => {
    const ta = aMillis(a.created_at);
    const tb = aMillis(b.created_at);
    if (ta !== null && tb !== null && ta !== tb) return tb - ta;
    return (Number(b.id) || 0) - (Number(a.id) || 0);
  });
